import { useGLTF, useTexture } from "@react-three/drei"
import { MeshBasicMaterial, sRGBEncoding } from "three"
import { InstanceMesh } from "../Components/BakedMeshComponents"
import { treesObject } from "../Utils/config/instanceData"

function InstanceGeometry() {
  const keys = Object.keys(treesObject)

  const { nodes } = useGLTF(
    `${process.env.PUBLIC_URL}/assets/apartmentfinder/instanceGeometry/treetypes.gltf`
  )

  const diffuseMap = useTexture(
    `${process.env.PUBLIC_URL}/assets/apartmentfinder/instanceGeometry/textures/treesTexture.jpg`
  )

  diffuseMap.flipY = false
  diffuseMap.encoding = sRGBEncoding

  const TREE_MAT = new MeshBasicMaterial({
    // color: "blue"
    // flatShading: true,
    map: diffuseMap
  })

  return keys.map(i => (
    <InstanceMesh key={i} treeType={i} nodes={nodes} TREE_MAT={TREE_MAT} />
  ))
  //   return <InstanceMesh />;
}

export default InstanceGeometry
